import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowEditorPage } from '@/features/workflows/graph/workflow-editor';
import { EntityName } from '@/features/references/entity-ref';

/** Modifier un workflow dans l'éditeur de graphe (ADR 0102) : enregistré en JSON Patch. */
export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/$workflowId/editor')({
  component: WorkflowEditorRoute,
});

function WorkflowEditorRoute() {
  const { tenant, projectId, workflowId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[
        { label: t('nav.items.workflows') },
        { label: <EntityName tenantId={tenant} kind="workflow" id={workflowId} scope={{ projectId }} /> },
        { label: t('workflowEditor.editGraph') },
      ]}
    >
      <WorkflowEditorPage tenantId={tenant} projectId={projectId} workflowId={workflowId} />
    </ConsoleShell>
  );
}
